<template>
  <hr class="border-gpx_gray-900" />
</template>

<script>
export default {};
</script>

<style></style>
